<template>
  <div class="central-apply-detail">
    <div class="apply-body">
      <header>
        <el-button @click="back">返 回</el-button>
        <el-button type="danger" @click="approval(1)" v-if="applyState == 3">审批驳回</el-button>
        <el-button type="primary" @click="approval(2)" v-if="applyState == 3">发布应用</el-button>
        <el-button type="primary" @click="applyCompileSave" v-if="applyState == 2 && funAuth.includes(29)">保存</el-button>
        <el-button type="primary" @click="applyCompileSave" v-if="applyState == 4 && funAuth.includes(35)">保存</el-button>
      </header>
      <el-form :model="form" :label-width="formLabelWidth">
        <el-form-item label="基本信息" class="header"></el-form-item>
        <el-form-item label="名称" class="must">
          <el-input v-model="form.template_name" maxlength="50" :readonly="applyState == 1"></el-input>
          <span class="err" v-if="istemplate_name">{{istemplate_name}}</span>
        </el-form-item>
        <el-form-item label="所属行业" class="must">
          <el-select v-model="form.fit_industry" multiple  placeholder="请选择" :disabled="applyState == 1">
          <el-option v-for="(item, index) in industry" :label="languageFilter(item.classify_name)" :value="item.id" :key="index"></el-option>
          </el-select>
          <span class="err" v-if="isfit_industry">{{isfit_industry}}</span>
        </el-form-item>
        <el-form-item label="应用分类" class="must">
          <el-select v-model="form.func_type" multiple placeholder="请选择" :disabled="applyState == 1">
          <el-option v-for="(item, index) in classification" :label="languageFilter(item.classify_name)" :value="item.id" :key="index"></el-option>
          </el-select>
          <span class="err" v-if="isfunc_type">{{isfunc_type}}</span>
        </el-form-item>
        <el-form-item label="角色分类" class="must">
          <el-select v-model="form.role_type" multiple placeholder="请选择" :disabled="applyState == 1">
          <el-option v-for="(item, index) in roleList" :label="languageFilter(item.classify_name)" :value="item.id" :key="index"></el-option>
          </el-select>
          <span class="err" v-if="isrole_type">{{isrole_type}}</span>
        </el-form-item>
        <el-form-item label="上传人" class="must">
          <el-input v-model="form.upload_user" maxlength="50" :readonly="applyState == 1"></el-input>
          <span class="err" v-if="isupload_user">{{isupload_user}}</span>
        </el-form-item>

        <el-form-item label="应用截图" class="header"></el-form-item>
        <el-form-item label="" class="file">
          <div class="tab-box2">
            <div class="tab-item" v-for="v in option5" :key="v.id" :class="{active: v.id==tabActive}" @click="tabActive=v.id">{{v.label}}</div>
          </div>
          <a href="javascript:;" class="file-btn" @click="fileApply($event, 1)" :class="(form.web_picture.length >= 8) ? 'disable':''" v-if="applyState != 1">
            <i class="iconfont icon-icon-test3"></i>
            <span>上传</span>
          </a>
          <input type="file" id="fileApply" @change="fileApply($event)" accept="image/*"  />
          <div class="file-right">
            <div class="img-box" v-if="tabActive==0">
              <div class="img" v-for="index in 8" :key="index">
                <img v-if="form.web_picture[index - 1]" :src="baseURL + form.web_picture[index - 1].file_url + '&TOKEN=' + token" />
                <div v-if="form.web_picture[index - 1] && applyState != 1" class="back" @click="removePic(index - 1)"></div>
                <i v-if="form.web_picture[index - 1] && applyState != 1" class="iconfont icon-close" @click="removePic(index - 1)"></i>
              </div>
            </div>
            <div class="img-box" v-if="tabActive==1">
              <div class="img" v-for="index in 8" :key="index">
                <template v-if="form.app_picture&&form.app_picture[index - 1]">
                  <img :src="baseURL + form.app_picture[index - 1].file_url + '&TOKEN=' + token" />
                  <div v-if="applyState != 1" class="back" @click="removePic(index - 1)"></div>
                  <i v-if="applyState != 1" class="iconfont icon-close" @click="removePic(index - 1)"></i>
                </template>
              </div>
            </div>
            <div class="remark" v-if="tabActive==0">请上传该应用的Web端截图，总共不超过8张。</div>
            <div class="remark" v-if="tabActive==1">请上传该应用的App端截图，总共不超过8张。</div>
            <span class="err" v-if="isweb_picture">{{isweb_picture}}</span>
          </div>
        </el-form-item>
        <el-form-item label="功能介绍" class="header"></el-form-item>
        <el-form-item label="应用描述" class="must">
          <el-input v-model="form.introduce" maxlength="500" type="textarea" rows="5" :readonly="applyState == 1" placeholder="请输入应用描述"></el-input>
          <span class="err" v-if="isintroduce">{{isintroduce}}</span>
        </el-form-item>
        <el-form-item label="收费信息" class="header"></el-form-item>
        <el-form-item label="是否收费" :label-width='formLabelWidth'>
          <el-radio-group v-model="form.charge_type">
          <el-radio v-for="(item, index) in option3" :key="index" :label="item.id" :disabled="applyState == 1">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价格" class="price" v-if="form.charge_type == 1">
          <el-input v-model="form.price" :readonly="applyState == 1" placeholder="请输入价格"></el-input>
          <span style="margin-left: 10px;color: #333;">RMB</span>
          <br />
          <span class="err" v-if="isprice">{{isprice}}</span>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth" v-if="form.charge_type == 1">
          <el-input v-model="form.contacts" :readonly="applyState == 1" placeholder="请输入"></el-input>
          <div class="err" v-if="iscontacts">{{iscontacts}}</div>
        </el-form-item>
        <el-form-item label="手机号码" :label-width="formLabelWidth" v-if="form.charge_type == 1">
          <el-input v-model="form.phone" :readonly="applyState == 1" placeholder="请输入"></el-input>
          <div class="err" v-if="isphone">{{isphone}}</div>
        </el-form-item>
        <!-- <el-form-item label="收款账号" class="account" v-if="form.charge_type == 1">
        <el-select v-model="form.payment_type" placeholder="请选择" :disabled="applyState == 1">
        <el-option v-for="(item, index) in option4" :label="item.label" :value="item.id" :key="index"></el-option>
        </el-select>
        <el-input v-model="form.receiv_account" :readonly="applyState == 1" placeholder="请输入账号"></el-input>
        <el-tooltip class="item" popper-class="collectionTip" effect="dark" placement="top"
        content="每一笔付款都需要经过7天的资金审核期，结束后款项会自动打入账号。收款账号非常重要，请谨慎填写。如填写有误，请及时联系Teamface客服联系。">
        <i class="el-icon-info" style="margin-left:10px;font-size: 18px;color: #F7BA2A;"></i>
        </el-tooltip>
        <br />
        <span class="err" v-if="isreceiv_account" style="margin: 8px 0 0 114px;">{{isreceiv_account}}</span>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="popUpBox" v-if="Colse">
      <div class="popUpBox-content">
        <div class="header_title"><span>{{contentTitle}}</span><i class="el-icon-close" @click="Colse=false"></i></div>
        <div class="popUpBox-content3" v-if="judgeNumber == 1">
          <p class="hintTitle">很遗憾您上传的应用未能通过审核。</p>
          <p>您可以尝试按照以下（包括但不限于）修改意见来调整您的应用以便重新提交至审核。</p>
          <el-input class="popUpBoxTextarea" type="textarea" :rows="8" placeholder="请输入内容" v-model="opinion" :maxlength="1000" resize="none"></el-input>
          <p class="submitAudit">Teamface 团队 审核于 {{currentTime | formatDate('yyyy-MM-dd')}}</p>
        </div>
        <div class="popUpBox-content3" v-if="judgeNumber == 2">
          <p class="hintContent">请设置哪些客户的版本可以安装此应用，功能版本和组件皆符合才可以安装。</p>
          <p style="line-height: 30px;">上传客户当前版本：旗舰版（功能版本）、全组件（组件版本）</p>
          <p class="title">哪些客户可安装此应用，功能版本为以下版本即可（多选）：</p>
          <p>
            <el-select multiple collapse-tags v-model="version" placeholder="请选择(必填)" size="medium">
              <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
            </el-select>
          </p>
          <p class="title">哪些客户可安装此应用，组件版本为以下版本即可（多选）：</p>
          <p>
            <el-select multiple collapse-tags v-model="field_typesId" placeholder="请选择(必填)" size="medium">
              <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
            </el-select>
          </p>
        </div>
        <div class="popUpBox-abolish">
          <el-button size="small" @click="Colse=false">取消</el-button>
          <el-button size="small" @click="rejected" v-if="judgeNumber == 1" style="background:#02152a;color:#fff;">确定</el-button>
          <el-button size="small" @click="release" v-if="judgeNumber == 2" style="background:#02152a;color:#fff;">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {appIndustry} from '@/common/js/constant.js'
import {HTTPServer, baseURL2} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
/**
 * state: 1-预览  2-编辑  3-驳回   4-发布
 */
export default {
  components: {},
  data () {
    return {
      // baseURL: sessionStorage.getItem('pictureAttachmentDomain') || baseURL2,
      baseURL: baseURL2,
      authId: [],
      applyState: 1, /** 1:已发布应用(详情) 2:已发布应用（编 辑） 3:待发布应用 4:热门应用 */
      formLabelWidth: '84px',
      classification: [], // 业务分类
      industry: [], // 行业分类
      roleList: [], // 角色分类
      option3: [{id: 0, label: '免费'}, {id: 1, label: '付费'}],
      option4: [{id: 0, label: '支付宝'}, {id: 1, label: '微信'}],
      option5: [{id: 0, label: 'PC截图'}, {id: 1, label: 'APP截图'}],
      form: {
        web_picture: [],
        charge_type: 1,
        fit_industry: [],
        func_type: [],
        role_type: []
      },
      istemplate_name: '',
      isfit_industry: '',
      isfunc_type: '',
      isrole_type: '',
      isupload_user: '',
      isweb_picture: '',
      isintroduce: '',
      isprice: '',
      iscontacts: '',
      isphone: '',
      token: '',
      Colse: false,
      judgeNumber: 0,
      opinion: '',
      currentTime: (new Date()).getTime(),
      responseData: this.roleRadioData,
      vOptions: [],
      version: [], // 功能版本
      componentData: [],
      field_typesId: [], // 组件版本
      tabActive: 0
    }
  },
  mixins: [mixin],
  watch: {
    roleRadioData (data) {
      console.log(data)
    },
    // 监听路由变化
    $route (to, from) {
      console.log(to, from)
      sessionStorage.getItem('prepage', from.name)
    }
  },
  /* 页面加载后执行 */
  mounted () {
    console.log(this)
    this.token = JSON.parse(sessionStorage.getItem('requestHeader')).TOKEN
    /** 快速新增添加 */
    var detail = this.$route.params.detail || sessionStorage.getItem('APPLYSTATE')
    console.log(111111, detail)
    if (detail) {
      this.applyState = parseInt(detail)
      sessionStorage.setItem('APPLYSTATE', detail)
      var moduleId
      if (this.applyState === 1) {
        moduleId = 8
      } else if (this.applyState === 2) {
        moduleId = 8
      } else if (this.applyState === 3) {
        moduleId = 9
      } else if (this.applyState === 4) {
        moduleId = 10
      }
      if (moduleId) {
        this.queryFchBtnAuth(({moduleId: moduleId}))
      }
    }
    var id = this.$route.query.id
    if (id) {
      this.applyId = parseInt(id)
      this.appClassifyList()
    }
  },
  methods: {
    // 语言过滤
    languageFilter (name) {
      if (JSON.stringify(name).includes('{\\"language\\"')) {
        if (typeof name === 'string') {
          return JSON.parse(name).language.zh
        } else {
          return name.language.zh
        }
      } else {
        return name
      }
    },
    /** 获取应用分类 */
    appClassifyList () {
      HTTPServer.appClassifyList({classifyType: ''}, 'Loading').then((res) => {
        this.classification = []
        this.industry = []
        this.roleList = []
        res.map(v => {
          if (v.classify_type === 1) {
            this.classification.push(v)
          } else if (v.classify_type === 2) {
            this.industry.push(v)
          } else if (v.classify_type === 3) {
            this.roleList.push(v)
          }
        })
        this.centralParticularsRequest()
      })
    },
    // 中央控制台的详情请求
    centralParticularsRequest () {
      HTTPServer.findApplicationById({'id': this.applyId}, 'Loading').then((res) => {
        this.apply = res
        let fitIndustry = []
        let funcType = []
        let roleType = []
        res.classifyInfo.map(v => {
          if (v.classify_type === 1) {
            funcType.push(v.id)
          } else if (v.classify_type === 2) {
            fitIndustry.push(v.id)
          } else if (v.classify_type === 3) {
            roleType.push(v.id)
          }
        })
        /** 视图更新 object */
        this.form = Object.assign({}, this.form, {
          id: res.application_id,
          template_name: res.template_name,
          fit_industry: fitIndustry,
          func_type: funcType,
          role_type: roleType,
          upload_user: res.upload_user,
          web_picture: res.web_picture ? JSON.parse(res.web_picture) : [],
          app_picture: res.app_picture ? JSON.parse(res.app_picture) : [],
          introduce: res.introduce,
          charge_type: parseInt(res.charge_type),
          price: res.price,
          icon_type: res.icon_type,
          icon_color: res.icon_color,
          icon_url: res.icon_url,
          payment_type: res.payment_type,
          phone: res.phone,
          contacts: res.contacts
        })
      })
    },
    /** 返回 */
    back (data) {
      this.$router.go(-1)
    },
    /** 上传文件 */
    fileApply (e, type) {
      if ((this.tabActive === 0 && this.form.web_picture.length >= 8) && (this.tabActive === 1 && this.form.app_picture.length >= 8)) {
        return
      }
      if (type === 1) {
        if (e.target.className.indexOf('disable') < 0) {
          document.getElementById('fileApply').click()
        }
      } else {
        console.log(e)
        if (!e.target.value) {
          console.log('为空！！！')
          return
        }
        var file = e.target.files[0]
        var fileType = file.type
        if (fileType.split('/')[0] === 'image') {
          let formdata = new FormData()
          formdata.append('userlogo', file)
          formdata.append('bean', 'user')
          HTTPServer.imageUpload(formdata, 'Loading').then((res) => {
            res.map((item) => {
              if (this.tabActive === 0) {
                this.form.web_picture.push(item)
              } else if (this.tabActive === 1) {
                this.form.app_picture.push(item)
              }
              console.log('form', this.form)
            })
          })
        }
        e.target.value = ''
      }
    },
    /** 移除图片 */
    removePic (i) {
      if (this.tabActive === 0) {
        this.form.web_picture.splice(i, 1)
      } else if (this.tabActive === 1) {
        this.form.app_picture.splice(i, 1)
      }
    },
    /** 数据校验 */
    verify () {
      this.istemplate_name = ''
      this.isfit_industry = ''
      this.isfunc_type = ''
      this.isrole_type = ''
      this.isupload_user = ''
      this.isweb_picture = ''
      this.isintroduce = ''
      this.isprice = ''
      this.iscontacts = ''
      this.isphone = ''
      if (!this.form.template_name) {
        this.istemplate_name = '应用名称不能为空'
        return false
      }
      if (this.form.fit_industry.length === 0) {
        this.isfit_industry = '所属行业不能为空'
        return false
      }
      if (this.form.func_type.length === 0) {
        this.isfunc_type = '应用分类不能为空'
        return false
      }
      if (this.form.role_type.length.length === 0) {
        this.isrole_type = '角色分类不能为空'
        return false
      }
      if (!this.form.upload_user) {
        this.isupload_user = '上传人不能为空'
        return false
      }
      if (this.form.web_picture.length === 0) {
        this.isweb_picture = '请至少上传一张应用图片'
        this.tabActive = 0
        return false
      }
      if (this.form.app_picture.length === 0) {
        this.isweb_picture = '请至少上传一张应用图片'
        this.tabActive = 1
        return false
      }
      if (this.form.web_picture.length > 8 || this.form.app_picture.length > 8) {
        return false
      }
      if (!this.form.introduce) {
        this.isintroduce = '描述不能为空'
        return false
      }
      if (this.form.charge_type === 1) {
        if (!this.form.price) {
          this.isprice = '价格不能为空'
          return false
        }
        if (isNaN(this.form.price)) {
          this.isprice = '格式错误'
          return false
        }
        if (!this.form.contacts) {
          this.iscontacts = '联系人不能为空'
          return false
        }
        if (!this.form.phone) {
          this.isphone = '手机号码不能为空'
          return false
        }
      }
      return true
    },
    /** 审批驳回 */
    rejected () {
      if (!this.opinion) {
        this.$message.error('审核意见不能为空')
        return
      }
      var jsondata = {
        'id': this.applyId, // 上传的应用id
        'status': this.judgeNumber, // 1 审核驳回 2 审批通过
        'view_content': this.opinion, // 意见
        'template_name': this.apply.template_name, // 上传的应用名称
        'classify_id': [...this.form.fit_industry, ...this.form.func_type, ...this.form.role_type], // 分类集合
        'upload_user': this.apply.upload_user, // 上传人
        'web_picture': this.apply.web_picture, // web图片
        'app_picture': this.apply.app_picture, // app图片
        'introduce': this.apply.introduce, // 介绍
        'customized': this.apply.customized, // 是否定制（0正常 1定制）
        'charge_type': this.apply.charge_type, // 收费类型（0免费 1付费）
        'price': this.apply.price, // 付款金额
        'company_id': this.apply.company_id,
        'application_id': this.apply.application_id,
        'payment_type': this.apply.payment_type,
        'phone': this.apply.phone, //  手机号码
        'contacts': this.apply.contacts //  联系人
      }
      this.auditRequest(jsondata)
    },
    /** 发布应用 */
    release (data) {
      console.log(data)
      if (this.version.length === 0) {
        this.$message({
          showClose: true,
          message: '功能版本不能为空!',
          type: 'error'
        })
        return
      }
      if (this.field_typesId.length === 0) {
        this.$message({
          showClose: true,
          message: '组件版本不能为空!',
          type: 'error'
        })
        return
      }
      var jsondata = {
        'id': this.applyId, // 上传的应用id
        'ampId': this.apply.a_m_id, // a_m_id
        'status': this.judgeNumber, // 1 审核驳回 2 审批通过
        'view_content': '', // 意见
        'template_name': this.form.template_name, // 上传的应用名称
        'classify_id': [...this.form.fit_industry, ...this.form.func_type, ...this.form.role_type], // 分类集合
        'upload_user': this.form.upload_user, // 上传人
        'web_picture': this.form.web_picture, // web图片
        'app_picture': this.form.app_picture, // app图片
        'introduce': this.form.introduce, // 介绍
        'customized': 0, // 是否定制（0正常 1定制）
        'charge_type': this.form.charge_type, // 收费类型（0免费 1付费）
        'price': this.form.price || 0, // 付款金额
        'company_id': this.apply.company_id,
        'application_ids': this.apply.application_ids,
        'fc_id': this.version.toString(),
        'cm_id': this.field_typesId.toString(),
        'payment_type': this.form.payment_type,
        'phone': this.form.phone, //  手机号码
        'contacts': this.form.contacts //  联系人
      }
      this.auditRequest(jsondata)
    },
    /** 审批状态的请求 (驳回、审批) */
    auditRequest (jsondata) {
      if (this.funAuth.indexOf(32) < 0) {
        this.$message({
          showClose: true,
          message: '无权限操作!',
          type: 'error'
        })
        return
      }

      console.log(jsondata)
      HTTPServer.approvalApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          type: 'success',
          message: (this.judgeNumber === 1) ? '驳回成功!' : '发布成功!'
        })
        this.back()
      })
    },
    /** 审批应用弹窗 */
    approval (type) {
      console.log(type)
      this.judgeNumber = type
      this.opinion = ''
      this.currentTime = (new Date()).getTime()
      this.contentTitle = (type === 1) ? '审核意见' : '发布应用'
      var verify = true
      if (type === 2) {
        verify = this.verify()
        if (verify) {
          this.version = []
          this.field_typesId = []
          this.queryAllChargingStrategy()
          this.getEnableComponentManageList()
        }
      }
      if (verify) this.Colse = true
    },
    /** 编辑-保存 */
    applyCompileSave () {
      if (this.funAuth.indexOf(29) < 0 && this.applyState === 2) {
        this.$message({
          showClose: true,
          message: '无权限操作!',
          type: 'error'
        })
        return
      }
      if (this.funAuth.indexOf(35) < 0 && this.applyState === 4) {
        this.$message({
          showClose: true,
          message: '无权限操作!',
          type: 'error'
        })
        return
      }
      var verify = this.verify()
      if (!verify) {
        return
      }
      var jsondata = {
        'id': this.applyId, // 上传的应用id
        'template_name': this.form.template_name, // 上传的应用名称
        'classify_id': [...this.form.fit_industry, ...this.form.func_type, ...this.form.role_type], // 分类集合
        'upload_user': this.form.upload_user, // 上传人
        'web_picture': this.form.web_picture, // web图片
        'app_picture': this.form.app_picture, // app图片
        'introduce': this.form.introduce, // 介绍
        'customized': 0, // 是否定制（0正常 1定制）
        'charge_type': this.form.charge_type, // 收费类型（0免费 1付费）
        'price': this.form.price || 0, // 付款金额
        'payment_type': this.form.payment_type,
        'phone': this.form.phone, //  手机号码
        'contacts': this.form.contacts //  联系人
      }
      console.log(jsondata)
      HTTPServer.updateApplication(jsondata, 'Loading').then((res) => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
        this.back()
      })
    },
    /** 获取 组件管理 */
    getEnableComponentManageList () {
      HTTPServer.getEnableComponentManageList({}, 'Loading').then((res) => {
        this.componentData = res
        this.queryAssemblyAndVersion()
      })
    },
    /** 获取 组件管理 */
    queryAssemblyAndVersion () {
      HTTPServer.queryAssemblyAndVersion({'ampId': this.apply.a_m_id}, 'Loading').then((res) => {
        if (res.cm_id) {
          res.cm_id.split(',').map(v => {
            this.field_typesId.push(parseInt(v))
          })
        }
        if (res.fc_id) {
          res.fc_id.split(',').map(v => {
            this.version.push(parseInt(v))
          })
        }
        console.log(res)
        console.log(this.version)
        console.log(this.field_typesId)
      })
    }
  },
  beforeDestroy () {
    sessionStorage.removeItem('APPLYSTATE')
    sessionStorage.removeItem('prepage')
  }
}
</script>

<style lang='scss'>
.central-apply-detail{
  height: 100%;
  padding: 0;
  .apply-body{
    width: 100%;
    height: 100%;
  }
  header{
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    .el-button{
      padding: 5px 16px;
      line-height: 22px;
    }
    .el-button--primary:hover{
      border: 1px solid #409EFF !important;
      color: #fff;
    }
    .el-button--danger:hover{
      border: 1px solid #f56c6c !important;
      color: #fff;
    }
    .el-button--default:hover{
      border: 1px solid #c6e2ff !important;
      color: #606266;
    }
  }
  form{
    padding: 0 20px;
    height: calc(100% - 60px);
    overflow-y: auto;
  }
  .header{
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eaeaea;
    .el-form-item__label{
      font-size: 16px;
      color: #000;
    }
  }
  .el-form-item__label{
    text-align: left;
  }
  .el-form-item__content{
    .el-input, .el-textarea, .el-select{
      width: 442px;
    }
  }
  .el-form-item.file{
    .el-form-item__content{
      margin-left: 0 !important;
    }
    .file-btn{
      width: 74px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid #D9D9D9;
      float: left;
      color: rgba(0,0,0,0.65);
    }
    input[type="file"]{
      display: none;
    }
    .file-right{
      margin: 0 0 0 84px;
      overflow: hidden;
      padding-bottom: 18px;
      .img-box{
        overflow: hidden;
        width: 400px;
        .img{
          background: rgba(48,84,199,0.03);
          border: 1px dashed #E1E1E1;
          border-radius: 4px;
          width: 80px;
          height: 53px;
          float: left;
          margin: 0 10px 10px 0;
          text-align: center;
          position: relative;
          img{
            width: 100%;
            height: 100%;
          }
          .back{
            width: 14px;
            height: 14px;
            background: #000;
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0.3;
            border-radius: 2px;
            cursor: pointer;
          }
          .iconfont{
            position: absolute;
            top: 1px;
            right: 1px;
            line-height: 1;
            font-size: 12px;
            color: #fff;
            cursor: pointer;
          }
        }
      }
      .remark{
        line-height: 1.2;
        font-size: 12px;
        color: #666666;
      }
    }
  }
  .el-form-item.price{
    .el-input{
      width: 100px;
    }
  }
  .el-form-item.account{
    .el-select{
      width: 100px;
      margin-right: 10px;
      .el-input{
        width: 100%;
      }
    }
    .el-input{
      width: 237px;
    }
  }
  .err{
    position: unset;
    display: block;
    margin: 8px 0 -15px 0;
    line-height: 1;
    font-size: 12px;
    color: red;
  }

  .popUpBox .popUpBox-content{
    width: 600px;
    textarea{
      width: 90%;
      height: 150px;
    }
    .hintTitle{
        line-height:50px;
        font-size: 17px;
    }
    .popUpBoxTextarea{
      margin:20px 0;
    }
    .submitAudit{
      padding-bottom:30px;
      border-bottom:1px solid #eee;
    }
    .affirmDelete{
      font-size:20px;
      color:#000;
      margin: 20px 0 40px 0;
    }
    .hintContent{
      color:#a1a1a1;
      font-size:15px;
      line-height: 20px;
      margin-top: 30px;
    }
  }
  .tab-box2{
    padding-top: 0;
    height: 33px;
    margin-bottom: 10px;
    .tab-item.active{
      background: #fff;
    }
  }
}
.popUpBox{
  background: rgba(0,0,0,.4);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  overflow: auto;
  .popUpBox-content{
    width: 600px;
    margin: 150px auto;
    background-color: #fff;
    padding: 20px 30px;
    .header_title{
      border-bottom: 1px solid #eee;
      line-height: 40px;
      span {
        font-size: 20px;
        color: #000;
      }
      i{
        float: right;
        line-height: 40px;
        cursor: pointer;
      }
    }
    .hintTitle {
      line-height: 50px;
      font-size: 17px;
    }
    textarea{
      width: 90%;
      height: 150px;
      margin: 20px 0;
    }
    .submitAudit{
      padding-bottom: 30px;
      border-bottom: 1px solid #eee;
    }
    .popUpBox-content3{
      .el-select{
        width: 100%;
      }
      .title{
        line-height: 40px;
      }
    }
  }
  .popUpBox-abolish{
    padding-top: 20px;
    overflow: auto;
    .el-button{
      background-color: #eee;
      color: #fff;
      border: none;
      width: 100px;
      float: right;
      margin-left: 20px;
      color: #000;
      border: 1px solid #eee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application/apply-detail.vue